<template>
  <div class="page" v-if="scriptLoaded && initialized">
    <div v-if="sportsBook">
      <Widget key="sportsbook" :config="sportsBookConfig" />
    </div>
    <div v-if="!sportsBook">
      <div class="tabs-container">
        <div class="tabs">
          <Tab
            customClass="tab"
            :active="activeWidgetsTab === 'Betting tournament/Promo'"
            :onClick="onPromoTabClick"
          >
            Betting tournament/Promo
          </Tab>
          <Tab
            customClass="tab"
            :active="activeWidgetsTab === 'Widgets'"
            :onClick="onWidgetTabClick"
          >
            Widgets
          </Tab>
          <Tab
            customClass="tab"
            :active="activeWidgetsTab === 'Playtracker'"
            :onClick="onPlaytrackerTabClick"
          >
            Playtracker
          </Tab>
          <Tab
            customClass="tab"
            :active="activeWidgetsTab === 'Betslip'"
            :onClick="onBetslipTabClick"
          >
            Betslip
          </Tab>
        </div>
      </div>
      <div
        v-if="activeWidgetsTab === 'Betting tournament/Promo'"
        v-for="widget in promoWidgets"
        v-bind:key="widget.name"
      >
        <div class="widget-name">{{ widget.name }}</div>
        <Widget :key="widget.name" :config="widget.config" />
      </div>

      <div
        v-if="activeWidgetsTab === 'Widgets'"
        v-for="widget in widgets"
        v-bind:key="widget.name"
      >
        <div class="widget-name">{{ widget.name }}</div>
        <Widget :key="widget.name" :config="widget.config" />
      </div>

      <div v-if="activeWidgetsTab === 'Playtracker'">
        <Widget key="playtracker" :config="playtrackerConfig" />
      </div>

      <div v-if="activeWidgetsTab === 'Betslip'">
        <Widget key="betslip" :config="betslipConfig" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Widget from "./Widget";
import Toggle from "./Toggle.vue";
import Tab from "./Tab.vue";

export default {
  components: { Tab, Toggle, Widget },
  props: {
    sportsBook: Boolean,
  },
  data() {
    return {
      sptFrame: null,
      scriptLoaded: false,
      sportsBookConfig: {
        onBetslipChanged: ({ betsTotal }) => {},
        onStateChange: ({ bets }) => {
          console.log("onStateChange", bets);
        },
        betslipZIndex: 101,
        onRecharge: this.onRecharge,
        onBetSlipStateChange: ({ isOpen }) => {},
        onRouteChange: (...params) => {
          console.log("onRouteChange", ...params);
        },
        onSessionRefresh: () => {
          console.log("--> onSessionRefresh");
          window.location.reload();
        },
        onLogin: function () {
          this.$router.push("/login");
        }.bind(this),
        onRegister: function () {
          this.$router.push("/registration");
        }.bind(this),
        onAppInitialized: () => {},
        onContactSupport: () => {
          console.log("contact support clicked");
        },
      },
      playtrackerConfig: {
        widgetName: "playtracker",
        widgetParams: {
          placeholder: "Play tracker",
          onRecharge: this.onRecharge,
          onLogin: () => {
            window.location.href = "http://my-site.com/sign-in";
          },
          onRegister: () => {
            window.location.href = "http://my-site.com/sign-up";
          },
          goToClick: (args) => {
            this.$router.push(`/sportsbook?bt-path=${args.url}`);
          },
        },
        onSessionRefresh: () => {
          console.log("--> onSessionRefresh");
          window.location.reload();
        },
      },
      betslipConfig: {
        widgetName: "betslip",
        betslipZIndex: 101,
        onSessionRefresh: () => {
          console.log("--> onSessionRefresh");
          window.location.reload();
        },
        onStateChange: ({ bets }) => {
          console.log("onStateChange", bets);
        },
        handlePageChange: (url, action) => {
          console.log("handlePageChange", url, action);
          this.$router[action === "REPLACE" ? "replace" : "push"](
            `/sportsbook${url}`
          );
        },
        onRecharge: this.onRecharge,
        onLogin: function () {
          this.$router.push("/login");
        }.bind(this),
        onRegister: function () {
          this.$router.push("/registration");
        }.bind(this),
        onContactSupport: () => {
          console.log("contact support clicked");
        },
      },
      promoWidgets: [
        {
          name: "Promo tournament",
          config: {
            widgetName: "promo_tournament",
            widgetParams: {
              placeholder: "promo_tournament",
            },
            onSessionRefresh: () => {
              console.log("--> onSessionRefresh");
              window.location.reload();
            },
          },
        },
        {
          name: "Promo",
          config: {
            widgetName: "promo",
            widgetParams: {
              placeholder: "operator_page1",
              onBannerClick: (args) => {
                this.onWidgetBannerClick(args);
              },
              onOutcomeClick: (args) => {
                console.log("onOutcomeClick", args);
                this.$router.push(
                  `/sportsbook?bt-path=${encodeURIComponent(args.url)}`
                );
              },
              withSportsList: false,
            },
            onSessionRefresh: () => {
              console.log("--> onSessionRefresh");
              window.location.reload();
            },
          },
        },
        {
          name: "Promo With Sports List",
          config: {
            widgetName: "promo",
            widgetParams: {
              placeholder: "operator_page",
              onBannerClick: (args) => {
                this.onWidgetBannerClick(args);
              },
              onOutcomeClick: (args) => {
                console.log("onOutcomeClick", args);
                this.$router.push(
                  `/sportsbook?bt-path=${encodeURIComponent(args.url)}`
                );
              },
              onSportClick: (args) => {
                this.$router.push(`/sportsbook?bt-path=${args.url}`);
              },
              withSportsList: true,
            },
          },
          onSessionRefresh: () => {
            console.log("--> onSessionRefresh");
            window.location.reload();
          },
        },
      ],
      widgets: [
        {
          name: "Top Match",
          config: {
            widgetName: "top_match",
            widgetParams: {
              placeholder: "top",
              onRecharge: this.onRecharge,
              onLogin: () => {
                window.location.href = "http://my-site.com/sign-in";
              },
              onRegister: () => {
                window.location.href = "http://my-site.com/sign-up";
              },
              goToClick: (args) => {
                this.$router.push(`/sportsbook?bt-path=${args.url}`);
              },
            },
            onSessionRefresh: () => {
              console.log("--> onSessionRefresh");
              window.location.reload();
            },
          },
        },
        {
          name: "Combo of the day",
          config: {
            widgetName: "combo_of_the_day",
            widgetParams: {
              placeholder: "middle",
              onRecharge: this.onRecharge,
              onLogin: () => {
                window.location.href = "http://my-site.com/sign-in";
              },
              onRegister: () => {
                window.location.href = "http://my-site.com/sign-up";
              },
              goToClick: (args) => {
                this.$router.push(`/sportsbook?bt-path=${args.url}`);
              },
            },
            onSessionRefresh: () => {
              console.log("--> onSessionRefresh");
              window.location.reload();
            },
          },
        },
        {
          name: "Top Outright",
          config: {
            widgetName: "top_outright",
            widgetParams: {
              placeholder: "bottom",
              onOutcomeClick: (args) => {
                console.log("onOutcomeClick", args);
                this.$router.push(
                  `/sportsbook?bt-path=${encodeURIComponent(args.url)}`
                );
              },
              goToClick: (args) => {
                this.$router.push(`/sportsbook?bt-path=${args.url}`);
              },
            },
            onSessionRefresh: () => {
              console.log("--> onSessionRefresh");
              window.location.reload();
            },
          },
        },
      ],
    };
  },
  computed: {
    ...mapState("auth", [
      "initialized",
      "isLoggedIn",
      "lang",
      "currency",
      "theme",
    ]),
    ...mapState("app", [
      "selectedBranch",
      "isPresentation",
      "activeWidgetsTab",
    ]),
  },
  methods: {
    onPromoTabClick() {
      this.$store.dispatch(
        "app/setActiveWidgetsTab",
        "Betting tournament/Promo"
      );
    },
    onWidgetTabClick() {
      this.$store.dispatch("app/setActiveWidgetsTab", "Widgets");
    },
    onPlaytrackerTabClick() {
      this.$store.dispatch("app/setActiveWidgetsTab", "Playtracker");
    },
    onBetslipTabClick() {
      this.$store.dispatch("app/setActiveWidgetsTab", "Betslip");
    },
    onWidgetBannerClick(args) {
      const isAbsoluteUrl = /^[a-z][a-z0-9+.-]*:/.test(args.url);

      if (isAbsoluteUrl) {
        window.location.href = args.url;
      } else {
        this.$router.push(`/sportsbook?bt-path=${args.url}`);
      }
    },
    loadScript() {
      const { BT_RENDERER_URL, ENV } = process.env;

      this.scriptLoaded = false;

      const scriptId = "bt-renderer";
      const existed = document.getElementById(scriptId);
      if (existed) {
        existed.remove();
      }

      const script = document.createElement("script");
      script.setAttribute("id", scriptId);

      const url = `${BT_RENDERER_URL.replace(/^https?:\/\//, "")}`;

      const path = `//${
        ENV !== "dev"
          ? url
          : this.selectedBranch === "master"
          ? "ui-test.sptpub.com"
          : this.selectedBranch === "beta"
          ? "ui.invisiblesport.com"
          : `${this.selectedBranch}.${url}`
      }`;
      const scriptFileName = `bt-renderer.min.js`;
      script.src = `${path}/${scriptFileName}`;
      const appendScript = (script) => {
        document.head.appendChild(script);
        script.onload = () => {
          this.scriptLoaded = true;
        };
      };

      if (!process.env.ENABLE_SRI) {
        return appendScript(script);
      }

      fetch(`${path}/entry-integrity.json`)
        .then((res) => res.json())
        .then((data) => {
          script.integrity = data[scriptFileName];
          script.crossOrigin = "anonymous";
          appendScript(script);
        });
    },

    onRecharge() {
      if (!this.isPresentation) {
        this.$store.dispatch("app/togglePopup", "top-up");
      }
    },
  },
  mounted() {
    if (this.initialized) {
      this.loadScript();
    }
  },
  watch: {
    initialized() {
      this.loadScript();
    },
    selectedBranch() {
      if (this.selectedBranch) {
        this.loadScript();
      }
    },
  },
};
</script>

<style scoped>
.page {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  text-align: center;
  height: 100%;
}
.tabs-container {
  padding: 8px;
}
.tabs {
  display: flex;
  background: rgba(142, 152, 157, 0.2);
  height: 32px;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
}
.tab {
  color: #fff;
}
.widget-name {
  color: #fff;
  font-weight: 600;
  font-size: 24px;
  padding-left: 16px;
  margin-top: 24px;
  margin-bottom: 8px;
  text-align: start;
}
</style>
